import { get, isEmpty } from 'lodash'
import { IPriceData, IPriceGridData, IRestrictionsData } from '../fetchPrices'
import { dateWithoutOffsert } from '../../License/mappers/mapResponseToLicense'

export type IPrices = any

export default function(item: IPriceGridData): IPrices {
  return {
    prices: !isEmpty(item.prices) ? item.prices.map(mapPrices) : [],
    restrictions: !isEmpty(item.restrictions)
      ? item.restrictions
          .filter(r =>
            someValue(r, [
              'restriction_close_at_arrival',
              'restriction_close_at_departure',
              'restriction_exact_stay',
              'restriction_max_before_arrival',
              'restriction_max_stay',
              'restriction_max_stay_thru',
              'restriction_min_before_arrival',
              'restriction_min_stay',
              'restriction_min_stay_thru',
            ]),
          )
          .map(mapRestrictions)
      : [],
    roomId: item.id_room,
  }
}

function someValue(values, arr: string[]) {
  return arr.map(r => get(values, r, false)).some(r => !!r)
}

function mapRestrictions(item: IRestrictionsData) {
  return {
    from: dateWithoutOffsert(new Date(item.restriction_day_from)),
    restrictionCloseAtArrival: item.restriction_close_at_arrival,
    restrictionCloseAtDeparture: item.restriction_close_at_departure,
    restrictionExactStay: item.restriction_exact_stay,
    restrictionMaxBeforeArrival: item.restriction_max_before_arrival,
    restrictionMaxStay: item.restriction_max_stay,
    restrictionMaxStayThru: item.restriction_max_stay_thru,
    restrictionMinBeforeArrival: item.restriction_min_before_arrival,
    restrictionMinStay: item.restriction_min_stay,
    restrictionMinStayThru: item.restriction_min_stay_thru,
    to: dateWithoutOffsert(new Date(item.restriction_day_to)),
  }
}

function mapPrices(item: IPriceData) {
  return {
    extrabed: !isEmpty(item.extrabed)
      ? {
          long: item.extrabed.long,
          short: item.extrabed.short,
          standard: item.extrabed.standard,
          weekend: item.extrabed.weekend,
        }
      : {},
    from: dateWithoutOffsert(new Date(item.price_day_from)),
    kids: item.kids ? item.kids.map(mapKids) : [],
    long: item.long,
    short: item.short,
    standard: item.standard,
    to: dateWithoutOffsert(new Date(item.price_day_to)),
    weekend: item.weekend,
  }
}

function mapKids(kid) {
  return {
    ageFrom: kid.age_from,
    ageTo: kid.age_to,
    kidId: kid.kid_id,
    long: kid.long,
    short: kid.short,
    standard: kid.standard,
    weekend: kid.weekend,
  }
}

export interface IPriceCategories {
  long: number
  short: number
  standard: number
  weekend: number
}

export interface IGridPriceKidComponent extends IPriceCategories {
  ageFrom: number
  ageTo: number
  kidId: number
}

interface ICategoryPrice {
  [key: number]: number
}

export interface IGridPrice {
  long: ICategoryPrice
  short: ICategoryPrice
  standard: ICategoryPrice
  weekend: ICategoryPrice
  from: Date
  to: Date
  extrabed: IPriceCategories
  kids: IGridPriceKidComponent[]
}
